import React from "react";
import { DataTableColumn } from "@sscs/ui";
import { GroupReservationIcon as GroupLimitIcon } from "@sscs/ui/icons";
import { PERMISSION } from "Constants";
import { useAllowedTo } from "Hooks";
import { SortGroups } from "../../types";
import styles from "./groupsTableHeader.module.scss";

/** The table's container title, rendered inside `Card.Title`. */
export const GroupsTableTitle = (): React.JSX.Element => (
  <span className={styles["table-title"]}>
    <GroupLimitIcon className={styles["title-icon"]} />
    Monthly usage for groups
  </span>
);

/**
 * Column definitions for the group-usage table, resolving the permission-gated
 * actions column via `useAllowedTo`. Passed to `DataTable`'s `columns` prop.
 */
export const useGroupsColumns = (): DataTableColumn<
  SortGroups["property"]
>[] => {
  const canAddLimit = useAllowedTo({
    permissions: [PERMISSION.ADD_GROUP_CAPACITY_LIMIT],
  });

  return [
    { id: "info", label: "Info", width: "80px" },
    {
      id: "group_name",
      label: "Group name",
      sortProperty: "group_name",
      width: "100%",
    },
    {
      id: "quota",
      label: "Monthly limit (GB)",
      sortProperty: "quota",
      startReverse: true,
      width: "300px",
    },
    {
      id: "used",
      label: "Used (GB)",
      sortProperty: "used",
      startReverse: true,
      width: "150px",
    },
    { id: "fileStream", label: "File stream (%)", width: "150px" },
    { id: "projects", label: "Projects (%)", width: "150px" },
    {
      id: "actions",
      label: "Actions",
      align: "center",
      width: "120px",
      hidden: !canAddLimit,
    },
  ];
};
